import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLibraryAdd = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M5.16699 10.498C4.72999 10.409 4.25599 10.426 3.76699 10.589C2.93999 10.865 2.28499 11.576 2.07999 12.424C1.65799 14.167 2.96699 15.723 4.63899 15.723C4.81999 15.723 4.99599 15.704 5.16699 15.67V18.89C5.16699 20.055 6.11199 21 7.27799 21H18.889C20.055 21 21 20.055 21 18.889V7.27796C21 6.11196 20.055 5.16696 18.889 5.16696H15.669C15.758 4.72996 15.741 4.25596 15.578 3.76696C15.301 2.93996 14.59 2.28496 13.743 2.07996C12 1.65796 10.444 2.96696 10.444 4.63896C10.444 4.81996 10.463 4.99596 10.497 5.16696H7.27699C6.11099 5.16696 5.16599 6.11196 5.16599 7.27796V10.498H5.16699Z",
			stroke: "#323232",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13 10.5V14.5",
			stroke: "#323232",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15 12.5H11",
			stroke: "#323232",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgLibraryAdd);
export default ForwardRef;
